var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41336 23.9815C7.41336 11.9815 16.2834 2.24147 27.4134 1.75147C26.2656 1.57022 25.1053 1.47994 23.9434 1.48146C17.976 1.48146 12.253 3.85199 8.03348 8.07156C3.81391 12.2911 1.44336 18.0141 1.44336 23.9815C1.44336 29.9488 3.81391 35.6718 8.03348 39.8914C12.253 44.1109 17.976 46.4815 23.9434 46.4815C25.1053 46.483 26.2656 46.3927 27.4134 46.2115C16.2834 45.7115 7.41336 35.9615 7.41336 23.9815Z",
    fill: "#D6F5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4531 31.7119H33.0931C33.3354 31.7092 33.5668 31.6112 33.7372 31.4389C33.9076 31.2667 34.0031 31.0342 34.0031 30.7919V17.1719L19.4531 31.7119Z",
    fill: "#D6F5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0837 16.252H14.7537C14.2512 16.252 13.8438 16.6594 13.8438 17.162V30.812C13.8438 31.3145 14.2512 31.722 14.7537 31.722H33.0837C33.5863 31.722 33.9937 31.3145 33.9937 30.812V17.162C33.9937 16.6594 33.5863 16.252 33.0837 16.252Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0638 16.2415C45.9661 18.7221 46.4264 21.3418 46.4238 23.9815C46.4238 29.9488 44.0533 35.6718 39.8337 39.8914C35.6142 44.1109 29.8912 46.4815 23.9238 46.4815C17.9565 46.4815 12.2335 44.1109 8.01392 39.8914C3.79435 35.6718 1.42383 29.9488 1.42383 23.9815C1.42383 18.0141 3.79435 12.2911 8.01392 8.07157C12.2335 3.852 17.9565 1.48147 23.9238 1.48147C26.4319 1.47747 28.923 1.89321 31.2938 2.71148",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7343 16.5117L24.6143 25.7117C24.5297 25.7967 24.4292 25.8641 24.3185 25.9101C24.2078 25.9561 24.0892 25.9798 23.9693 25.9798C23.8494 25.9798 23.7307 25.9561 23.62 25.9101C23.5094 25.8641 23.4088 25.7967 23.3243 25.7117L14.1543 16.5517",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1628 9.21129L40.2328 4.44129C40.2317 4.35624 40.1998 4.27447 40.1428 4.21129L40.0228 4.12129H38.9528C38.9094 4.11969 38.8663 4.12783 38.8264 4.14514C38.7866 4.16245 38.7512 4.18847 38.7228 4.22129L38.6328 4.34129L38.7628 9.21129H40.1628Z",
    fill: "#BD2D00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4626 10.041C39.1788 10.041 38.9066 10.1537 38.706 10.3544C38.5053 10.5551 38.3926 10.8272 38.3926 11.111C38.3926 11.3948 38.5053 11.667 38.706 11.8676C38.9066 12.0683 39.1788 12.181 39.4626 12.181C39.7446 12.1784 40.0142 12.0645 40.2127 11.8641C40.4112 11.6637 40.5226 11.3931 40.5226 11.111C40.5226 10.829 40.4112 10.5583 40.2127 10.3579C40.0142 10.1575 39.7446 10.0437 39.4626 10.041Z",
    fill: "#BD2D00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8705 7.3412L40.1641 1.63484C39.7736 1.24432 39.1404 1.24432 38.7499 1.63484L33.0436 7.34119C32.6531 7.73171 32.6531 8.36488 33.0436 8.7554L38.7499 14.4618C39.1405 14.8523 39.7736 14.8523 40.1641 14.4618L45.8705 8.75541C46.261 8.36489 46.261 7.73172 45.8705 7.3412Z",
    stroke: "#BD2D00",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.9d545676da11d45e478ec2b49a9d7eb5.svg";
export { ForwardRef as ReactComponent };